import { FolderIdentification } from './folder-identification';

export class FolderWaitingArchivingStateToggleNotification {
    public viewId: number;
    public IsWaitingArchiving: boolean;
    public folderIdentifications: FolderIdentification[];

    public static fromJson(other: any): FolderWaitingArchivingStateToggleNotification {
        const instance = new FolderWaitingArchivingStateToggleNotification();
        instance.viewId = other.ViewId;
        instance.IsWaitingArchiving = other.IsWaitingArchiving;
        instance.folderIdentifications = other.FolderIdentifications;
        return instance;
    }
}
